var module = angular.module('octopusApp.projects');

module.directive('azurePowershellAccountInfo', function () {
    return {
        restrict: 'E',
        replace: true,
        templateUrl:'areas/projects/actions/azure_powershell/azure_powershell_account_info.html'
    };
});



//////////////////
// WEBPACK FOOTER
// ./app/areas/projects/actions/azure_powershell/azure_powershell_account_info.js
// module id = 488
// module chunks = 1